export default __webpack_public_path__ + "static/media/clarity.ed6cb07d.png";